import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UnreachableVehicleMapViewComponent } from './unreachable-vehicle-map-view.component';

@Component({
  selector: 'app-unreachable-vehicle-alert',
  templateUrl: './unreachable-vehicle-alert.component.html',
  styleUrls: ['./unreachable-vehicle-alert.component.scss']
})
export class UnreachableVehicleAlertComponent implements OnDestroy {
  alerts: any[] = [];
  private mapDialogRef: MatDialogRef<UnreachableVehicleMapViewComponent>;

  constructor(
    public dialogRef: MatDialogRef<UnreachableVehicleAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly apiService: ApiService,
    private readonly notifyService: NotificationService,
    private readonly ngxLoader: NgxUiLoaderService,
    private readonly dialog: MatDialog
  ) {
    this.alerts = Array.isArray(data) ? data : (data ? [data] : []);
  }

  openMapView(alert: any): void {
    if (!this.hasMapLocation(alert)) {
      return;
    }
    if (this.mapDialogRef) {
      this.mapDialogRef.close();
    }
    this.mapDialogRef = this.dialog.open(UnreachableVehicleMapViewComponent, {
      width: '750px',
      data: alert,
      panelClass: 'custom-dialog-container'
    });
    this.mapDialogRef.afterClosed().subscribe(() => {
      this.mapDialogRef = null;
    });
  }

  hasMapLocation(alert: any): boolean {
    return this.displayLatLong(alert) !== 'NA';
  }

  doIVRCall(tripId: string): void {
    this.ngxLoader.start();
    const url = `${ApiConstants.ivrCallForUnreachableVehicle}${tripId}`;
    this.apiService.doPostRequestWithResponse(url, '', success => this.ngxLoader.stop(),
      error => {
        this.ngxLoader.stop();
        console.log(error);
      });
  }

  onClose(): void {
    this.closeMapDialog();
    this.dialogRef.close('close');
  }

  ngOnDestroy(): void {
    this.closeMapDialog();
  }

  private closeMapDialog(): void {
    if (this.mapDialogRef) {
      this.mapDialogRef.close();
      this.mapDialogRef = null;
    }
  }

  displayValue(value: any): string {
    if (value == null || value === '' || value === 'null' || value === 'undefined') {
      return 'NA';
    }
    return String(value);
  }

  displayLatLong(alert: any): string {
    const latitude = alert?.latitude;
    const longitude = alert?.longitude;
    if (this.isInvalidCoordinate(latitude) || this.isInvalidCoordinate(longitude)) {
      return 'NA';
    }
    const lat = Number(latitude);
    const lng = Number(longitude);
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return 'NA';
    }
    return `${latitude}, ${longitude}`;
  }

  private isInvalidCoordinate(value: any): boolean {
    return value == null || value === '' || value === 'NA' || value === 'null' || value === 'undefined';
  }
}
